// extracted by mini-css-extract-plugin
export default {"newProduct":"СolorAdditionalAccent_newProduct__YrNLK","someOne":"СolorAdditionalAccent_someOne__fPnbo","title":"СolorAdditionalAccent_title__+FRXp"};